import React, {Component} from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {connect} from "react-redux";
import moment from "moment/moment";
import 'react-day-picker/lib/style.css';

import {Button, Modal, Form, Grid, Message} from 'semantic-ui-react';
import MaskedInput from "react-text-mask";
import update from 'react-addons-update';
import ExpenseData from "../../data/ExpenseData";
import ProductsIngredientsData from "../../data/ProductsIngredientsData";
import {openModalExpense} from "../../actions/ModalExpenseActions";
import ExpenseDetail from "./ExpenseDetail";
import {showToast} from "../../actions/ToastAction";
import localDB from "../../data/localDB";
import {providerDialog} from "../../actions/ProviderDialogAction";
import {selectProvider} from "../../actions/ProviderSelectAction";
import {expenseSelectAction} from "../../actions/ExpenseSelectAction";
import helpers from "../../functions/helpers";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
const c = require("../../constants");

const moneyMask = createNumberMask({
    prefix: '$',
});

class ExpenseDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            expense: {
                date: new Date().toISOString().substring(0, 10),
                type: 1,
                payment_method: 1,
                id: null,
                invoice_number: '',
                amount: 0,
                observations: '',
                provider: null,
                location: props.location
            },
            providers: [],
            date_error: false,
            name_error: false,
            amount_error: false,
            provider_error: false,
            sending: false,
            loading: true,
            id: null,
            products_ingredients: []
        };

        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleDateClick = this.handleDateClick.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleInvoiceNumberChange = this.handleInvoiceNumberChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handleObservationsChange = this.handleObservationsChange.bind(this);
        this.handleProviderChange = this.handleProviderChange.bind(this); 
        this.handleMethodPaymentChange = this.handleMethodPaymentChange.bind(this);
        this.handleSearchProvider = this.handleSearchProvider.bind(this);
    }

    componentDidMount() {
        this.initialFetch();
    }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.provider_select && nextProps.provider_select.id) {
            setTimeout(() => {
                this.handleProviderChange(nextProps.provider_select.id);
                this.setState({providers: helpers.mapProviders([nextProps.provider_select])})
            }, 10);

        }
        if (nextProps.modal.expense && nextProps.modal.expense.id !== this.state.id) {
            this.setState({
                loading: true,
                height: 80,
                id: nextProps.modal.expense.id,
                expense: nextProps.modal.expense,
                location: this.props.location
            });
            if(nextProps.modal.expense.provider){
                this.handleSearchProvider(null, {searchQuery:nextProps.modal.expense.provider})
            }
        }
    };

    handleSearchProvider = (e, value) => {
        localDB.findProviders(value.searchQuery).then(data => {
            this.setState({providers: helpers.mapProviders(data)});
        })
    };

    initialFetch() {
        ProductsIngredientsData.list().then(data => {
            this.setState({products_ingredients: data});
        });
    }

    handleTypeChange = (result) => {
        let type = update(this.state, {
            expense: {
                type: {$set: result},
            }
        });
        this.setState(type);
    };

    handleMethodPaymentChange = (result) => {
        let payment_method = update(this.state, {
            expense: {
                payment_method: { $set: result },
            }
        });
        this.setState(payment_method);
    };

    handleAmountChange = (event) => {
        let value = isNaN(parseFloat(event.target.value.replace(/\D/g, ''))) ? '':parseFloat(event.target.value.replace(/\D/g, ''));
        let amount = update(this.state, {
            expense: {
                amount: {
                    $set: value
                }
            }
        });
        this.setState(amount);
        if (event.target.value < 0) {
            this.setState({amount_error: true})
        } else {
            this.setState({amount_error: false});
        }
    };

    handleNameChange = (event) => {
        let name = update(this.state, {
            ingredient: {
                name: {
                    $set: event.target.value
                }
            }
        });
        this.setState(name);
        if (event.target.value.trim() === '') {
            this.setState({name_error: true})
        } else {
            this.setState({name_error: false});
        }
    };

    handleObservationsChange = (event) => {
        let observations = update(this.state, {
            expense: {
                observations: {
                    $set: event.target.value
                }
            }
        });
        this.setState(observations);
    };

    handleInvoiceNumberChange = (event) => {
        let invoice_number = update(this.state, {
            expense: {
                invoice_number: {
                    $set: event.target.value
                }
            }
        });
        this.setState(invoice_number);
    };

    handleDateChange = (event) => {
        let date = update(this.state, {
            expense: {
                date: {
                    $set: event.target.value
                }
            }
        });
        this.setState(date);
        if (event.target.value.trim() === '') {
            this.setState({date_error: true})
        } else {
            this.setState({date_error: false});
        }
    };

    clearForm = () => {
        let type = update(this.state, {
            expense: {
                type: {$set: 1},
                id: {$set: null},
                invoice_number: {$set: ''},
                amount: {$set: 0},
                observations: {$set: ''},
                location: {$set: this.props.location}
            }
        });
        this.setState(type);
    };

    handleDateClick = (selectedDay) => {
        let date = update(this.state, {
            expense: {
                date: {
                    $set: moment(selectedDay).format("YYYY-MM-DD")
                }
            }
        });
        this.setState(date);
        this.setState({date_error: false});
    };

    handleProviderChange = (result) => {
        let id = result === '0' ? null : result;
        let provider = update(this.state, {
            expense: {
                provider: {$set: id}
            }
        });
        this.setState(provider);
    };

    async handleSubmit(event) {
        event.preventDefault();
        if (this.state.expense.date === '') {
            this.setState({date_error: true});
        } else if (this.state.expense.amount < 0) {
            this.setState({amount_error: true});
        } else {
            this.setState({disabled_button: true, sending: true});
            if (this.props.modal.expense) {
                ExpenseData.update(this.state.expense, (res) => {
                    if (res !== null && res.hasOwnProperty('id')) {
                        this.props.expenseSelect(res);
                        this.props.selectProvider({id: null, full_name: ''});
                        this.props.showToast({message: 'Gasto Actualizado!', type: 'success'});
                    } else {
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                    }
                    this.setState({disabled_button: false, sending: false});
                });
            } else {
                ExpenseData.add(this.state.expense, (res) => {
                    if (res.save) {
                        this.clearForm();
                        this.props.expenseSelect(res.expense);
                        this.props.selectProvider({id: null, full_name: ''});
                        this.props.showToast({message: 'Gasto Agregado!', type: 'success'});
                        this.props.openModalExpense({show: true, expense: res.expense})
                    } else {
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                    }
                    this.setState({disabled_button: false, sending: false});
                });
            }
        }
    };

    handleClose = () => {
        this.setState({
            loading: true,
            id: null,
            sending: false,
            expense: {
                date: new Date().toISOString().substring(0, 10),
                type: 1,
                id: null,
                invoice_number: '',
                amount: 0,
                observations: '',
                provider: null,
                location: this.props.location
            }
        });
        this.props.openModalExpense({show: false, expense: null});
        this.props.selectProvider({id: null, full_name: ''});
    };

    handleAddProvider = (e, {value}) => {
        this.props.providerDialog({
            open: true,
            provider: {id: null, full_name: value, provider: null, factory: '', email: '', phone: '', phone_prefix: '+57'}
        });
    };

    render() {
        return (
            <div>
                <Modal
                    size='large'
                    dimmer='inverted'
                    open={this.props.modal.show}
                    onClose={this.handleClose}
                >
                    <Modal.Header>{this.props.modal.expense ? 'Editar Gasto' : 'Agregar Gasto'}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            {this.state.expense.location === 'expenses' ? <Message negative header='Información' content='Los gastos que registres desde aquí no se verán reflejados en el cierre de caja, pero si en los informes y reportes.'/>:null}
                            <Form>
                                <Grid stackable divided>
                                    <Grid.Row>
                                        <Grid.Column width={4}>
                                            <Form.Field error={this.state.date_error}>
                                                <label>Fecha</label>
                                                <DayPickerInput readOnly placeholder="YYYY-MM-DD" format="YYYY-MM-DD"
                                                                value={this.state.expense.date}
                                                                onDayChange={this.handleDateClick}
                                                                onChange={this.handleDateChange}/>
                                            </Form.Field>
                                            <Form.Select label='Proveedor' search allowAdditions clearable
                                                         additionLabel={<i style={{color: '#e44745'}}>Nuevo Proveedor: </i>}
                                                         options={this.state.providers}
                                                         lazyLoad={true}
                                                         onAddItem={this.handleAddProvider}
                                                         value={this.state.expense.provider ? this.state.expense.provider : null}
                                                         onSearchChange={this.handleSearchProvider}
                                                         onChange={(e, {value}) => this.handleProviderChange(value)}
                                                         placeholder='Proveedor'/>
                                            <Form.Select placeholder='Tipo de Gasto' label='Tipo de Gasto'
                                                         options={c.EXPENSE_TYPES} value={this.state.expense.type}
                                                         onChange={(e, {value}) => this.handleTypeChange(value)}
                                                         error={this.state.type_error}/>
                                            <Form.Select placeholder='Medio de Pago' label='Medio de Pago'
                                                options={c.EXPENSE_PAYMENT_METHODS} value={this.state.expense.payment_method}
                                                onChange={(e, { value }) => this.handleMethodPaymentChange(value)}
                                                error={this.state.payment_method_error} />
                                        </Grid.Column>
                                        <Grid.Column width={4}>
                                            <Form.Input label='Nº Factura' placeholder='Nº Factura'
                                                        value={this.state.expense.invoice_number}
                                                        onChange={this.handleInvoiceNumberChange}/>
                                            <Form.Input label='Valor'
                                                        onChange={this.handleAmountChange}
                                                        error={this.state.amount_error}
                                                        children={
                                                            <MaskedInput
                                                                mask={moneyMask}
                                                                value={this.state.expense.amount}
                                                                placeholder='Valor'
                                                                onChange={this.handleAmountChange}
                                                            />
                                                        }
                                            />
                                            <Form.TextArea label='Observaciones' placeholder='Observaciones'
                                                           value={this.state.expense.observations}
                                                           onChange={this.handleObservationsChange}/>
                                        </Grid.Column>
                                        <Grid.Column width={8}>
                                            <ExpenseDetail
                                                id={this.props.modal.expense ? this.props.modal.expense.id : null}
                                                products_ingredients={this.state.products_ingredients}
                                            />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cerrar"/>
                        <Button primary icon='save' disabled={this.state.sending}
                                loading={this.state.sending} labelPosition='left' onClick={this.handleSubmit}
                                content={this.props.modal.expense ? 'Actualizar' : 'Guardar'}/>
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        modal: state.get('expense_dialog'),
        provider_select: state.get('provider_select'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        openModalExpense(modal) {
            dispatch(openModalExpense(modal))
        },
        showToast(toast) {
            dispatch(showToast(toast))
        },
        providerDialog(data) {
            dispatch(providerDialog(data))
        },
        selectProvider(data) {
            dispatch(selectProvider(data))
        },
        expenseSelect(data) {
            dispatch(expenseSelectAction(data))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ExpenseDialog)




// WEBPACK FOOTER //
// ./src/components/expenses/ExpenseDialog.js